import React from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'

import { clearall, updateProps, updateRadius, updateSliderBackground, closeCanvas, changeColor, handleChange, changeRadius, updateCanvasDiv, statename, saveCanvas, loadCanvas, canvasCleanup, handleRedo, handleUndo, handleCanvasChange, toggleUndoRedo, clearUndoRedoStack,handleChangeOpacity,ShouldEyeIconRender } from '../states/currentstate'
import { enableNote, closeNotes, saveNotes, notesCleanup, disableNote } from "../states/noteState";

const Toolbox = (props) => {
  const currentState = useSelector((state) => state.current)
  const dispatch = useDispatch()
  const myRef = React.createRef(null);

  const tool = [
    {
      name: "Pencil",
      class: "opr-draw-all-icons oprPencilIcon ",
      iconColor: currentState.color,
      sizes: [2, 4, 6, 8, 10],
      color: [],
      show: true,
      click: undefined,
      clear: [],
    },
    {
      name: "Highlighter",
      class: "opr-draw-all-icons oprHighlighterIcon",
      iconColor: currentState.color,
      sizes: [35, 40, 45, 50, 55],
      color: [],
      show: true,
      click: undefined,
      clear: [],

    },
    {
      name: "Eraser",
      class: "opr-draw-all-icons oprEraserIcon",
      iconColor: "",
      sizes: [10, 20, 30, 40, 50],
      color: [],
      show: true,
      click: undefined,
      clear: ['Clear'],
    },
    {
      name: "Ellipse",
      class: "opr-draw-all-icons oprEllipseIcon",
      iconColor: currentState.color,
      color: [],
      sizes: [2, 4, 6, 8, 10],
      show: true,
      click: undefined,
      clear: [],
    },
    {
      name: "Rectangle",
      class: "opr-draw-all-icons oprRectangleIcon",
      iconColor: currentState.color,
      color: [],
      sizes: [2, 4, 6, 8, 10],
      show: true,
      click: undefined,
      clear: [],
    },

    {
      name: "Color",
      class: "opr-draw-all-icons oprColorIcon",
      iconColor: currentState.color,
      //color: ['#D7648D','#9E88AF','#AB8376' ,'#DEB3B9' ,'#AF6C4D','#ACA8A8','#161111','#0066CC','#263EA3','#4289DB','#8BABB9','#88D2C5','#FF3300','#CC6600','#FF6600','#D58818','#DAC826','#FFCC33','#009999','#41806E','#AAD2B2','#4ED940','#52D646','#B4D657'],
      color: ['#1B4488', '#0096C7', '#D66555', '#E8C041', '#BB2BBA', '#851EC9'],    
      sizes: [],
      show: true,
      click: undefined,
      clear: [],
    },
    {
      name: "Notes",
      class: "opr-draw-all-icons oprNotesIcon",
      iconColor: currentState.color,
      // color: ['#D7648D','#9E88AF','#AB8376' ,'#DEB3B9' ,'#AF6C4D','#ACA8A8','#161111','#0066CC','#263EA3','#4289DB','#8BABB9','#88D2C5','#FF3300','#CC6600','#FF6600','#D58818','#DAC826','#FFCC33','#009999','#41806E','#AAD2B2','#4ED940','#52D646','#B4D657'],
      color: [],
      sizes: [],
      show: true,
      click: enableNote,
      clear: [],
    },
    {
      name: "Undo",
      class: "opr-draw-all-icons oprUndoIcon",
      iconColor: "",
      color: [],
      sizes: [],
      show: true,
      click: handleUndo,
      clear: [],
      disabled: currentState.showUndo

    },
    {
      name: "Redo",
      class: "opr-draw-all-icons oprRedoIcon",
      iconColor: "",
      color: [],
      sizes: [],
      click: handleRedo,
      show: true,
      clear: [],
      disabled: currentState.showRedo
    }

  ]

  useEffect(() => {
    //deletiing old canvas and notes data 
    Global.isFOCActive = true
    canvasCleanup()
    notesCleanup()
    ShouldEyeIconRender()
    // dispatch(setReaderComponent("disabled"))
  }, [])
  useEffect(() => {
    dispatch(updateProps(props))
    dispatch(updateRadius(currentState.radius))
    dispatch(updateSliderBackground(myRef))
  }, [])
  useEffect(() => {
    if (currentState.canvasObj != "") {
      dispatch(loadCanvas())
      dispatch(clearUndoRedoStack())
      dispatch(toggleUndoRedo())
      currentState.canvasObj.canvas.addEventListener("mouseup", (evt) => { dispatch(handleCanvasChange(evt)); dispatch(toggleUndoRedo()) })
      currentState.canvasObj.canvas.addEventListener("touchend", (evt) => { dispatch(handleCanvasChange(evt)); dispatch(toggleUndoRedo()) })
    }
  }, [currentState.canvasObj])
  useEffect(()=>{
    if(currentState.canvasObj){
      if(currentState.focmode)
        currentState.canvasObj.containerEl.classList.add("pointernone");
      else
        currentState.canvasObj.containerEl.classList.remove("pointernone");
    }
  },[currentState.focmode,currentState.canvasObj])
  return (<div>
    <ul className="oprFocList">
      {

        tool.map((e, i) =>
          <li key={i} className={e.name}>
            <button style={{ color: e.iconColor }}
              key={i}
              disabled={e.disabled || false}
              id={e.name}
              aria-label={e.name}
              title={e.name}
              className={(currentState.selecteditem === e.name) ? e.class + ' selected' : e.class}
              //aria-expanded={currentState.showSecondary && currentState.selectedtool === e.name ? "true" : "false"}
              aria-expanded={["Notes", "Undo", "Redo"].includes(e.name) ? undefined : currentState.showSecondary && currentState.selectedtool === e.name ? "true" : "false"}
              aria-haspopup={
                ["Notes", "Undo", "Redo"].includes(e.name)
                  ? undefined
                  : "listbox"
              }
              aria-labelledby={
                ["Notes", "Undo", "Redo"].includes(e.name)
                  ? undefined
                  : `${e.name}-stroke`
              }
              aria-controls={
                ["Notes", "Undo", "Redo"].includes(e.name)
                  ? undefined
                  : "selected-" + e.name + "List"
              }
              type="button"
              onClick={e.click ? () => { dispatch(e.click()), dispatch(statename(e)) } : () => {dispatch(disableNote()),dispatch(statename(e))}}>
              {(e.name === 'Color') ? <span style={{ backgroundColor: currentState.color }}></span> : null}
              {(e.name === "Pencil" || e.name === "Highlighter" || e.name === "Eraser") ? <span className="selectedColor opr-draw-all-icons" style={{ color: currentState.color }}></span> : null}

            </button>
            {currentState.showSecondary && currentState.selectedtool == e.name ? <ul id={"selected-" + e.name + "List"} className={"oprPalette " + currentState.selectedtool} role="listbox" aria-labelledby={e.name + "-stroke"} tabindex={currentState.selectedtool === e.name ? 0 : -1}>
              {e.color.length ? e.color.map((i, j) => {
                return (
                  <>
                    <li key={j}> <button onClick={() => dispatch(changeColor(i))}>  {<span  title ={`color ${j + 1}`} aria-label={`color ${j + 1}`}  style={{ backgroundColor: i }}></span>} </button>  </li>
                    {(j === e.color.length - 1) ?
                      <li key={j}><div className="opacityWrap">
                        <h6>Opacity</h6>
                        <input id="opacitySlider" type="range" min={currentState.min} max={currentState.max} value={currentState.value} aria-label={`range-${currentState.value}`} title={`range-${currentState.value}`} onChange={(e) => dispatch(handleChange(e.target.value))} onMouseUp={(e)=>{dispatch(handleChangeOpacity(e.target.value))}}
                          step="1" ref={myRef} />
                        <div className="clearfix">
                          <span className="opr-float-l">20%</span>
                          <span className="opr-float-r">100%</span>
                        </div>
                      </div></li> : null}
                  </>
                )
              }
              ) : null}
              {e.sizes.length ? e.sizes.map((i,index) => <li key={i}> <button id={`stroke-${index + 1}`} className={(currentState.radius === i) ? "stroke-" + i + ' selected' : "stroke-" + i} style={{ color: (currentState.selectedtool != 'Eraser') ? currentState.color : null }} aria-label={`${e.name} stroke ${index + 1}`} title={`${e.name} stroke ${index + 1}`} role="option" aria-selected={currentState.radius === i} onClick={() => dispatch(changeRadius(i))}>  </button></li>) : null}
              {e.clear.map((i) => <li key={i}> <button id={i} className="opr-draw-all-icons clearAll" aria-label='Eraser-ClearAll' title='Eraser-ClearAll' onClick={() => { dispatch(clearall(i)) }}>  </button> </li>)}
            </ul> : null}
          </li>
        )
      }
    </ul>


    <button id="closebtn" className="oprCloseCanvasBtn opr-all-icons close" hidden={currentState.hideCloseBtn} onClick={() => {
      dispatch(saveNotes())
      dispatch(closeNotes())
      dispatch(saveCanvas())
      dispatch(closeCanvas())
      props.closeCallback()
      // Global['FOCPREVIEW_MASTER'] = ''
    }}> Close Markup Mode </button>
  </div>)
}
export default Toolbox

